var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7063",
    "data-name": "Rectangle 7063",
    width: 48,
    height: 48,
    transform: "translate(726 405)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_transactions",
    "data-name": "Online transactions",
    transform: "translate(-726 -405)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19695",
    "data-name": "Group 19695",
    transform: "translate(731.954 413.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_670",
    "data-name": "Mask Group 670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19655",
    "data-name": "Group 19655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9364",
    "data-name": "Group 9364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9348",
    "data-name": "Group 9348",
    transform: "translate(0.003 15.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20999",
    "data-name": "Path 20999",
    d: "M1021.267,624.852h-6.086a15.36,15.36,0,0,0,1.509,5.891h5.209A32.917,32.917,0,0,1,1021.267,624.852Z",
    transform: "translate(-1015.181 -624.852)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9349",
    "data-name": "Group 9349",
    transform: "translate(2.438 23.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21000",
    "data-name": "Path 21000",
    d: "M1018.042,633.715a14.633,14.633,0,0,0,6.61,5.549,33.775,33.775,0,0,1-1.949-5.549Z",
    transform: "translate(-1018.042 -633.715)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9350",
    "data-name": "Group 9350",
    transform: "translate(8.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21001",
    "data-name": "Path 21001",
    d: "M1025.63,612.893h4.751v-6.61a14.073,14.073,0,0,0-2.183.3A32.165,32.165,0,0,0,1025.63,612.893Z",
    transform: "translate(-1025.63 -606.283)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9352",
    "data-name": "Group 9352",
    transform: "translate(2.44 0.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21003",
    "data-name": "Path 21003",
    d: "M1024.94,607.39a14.618,14.618,0,0,0-6.9,5.667h4.8A33.743,33.743,0,0,1,1024.94,607.39Z",
    transform: "translate(-1018.044 -607.39)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9353",
    "data-name": "Group 9353",
    transform: "translate(15.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21004",
    "data-name": "Path 21004",
    d: "M1033.085,612.893h4.751a32.067,32.067,0,0,0-2.568-6.313,14.053,14.053,0,0,0-2.183-.3Z",
    transform: "translate(-1033.085 -606.283)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9354",
    "data-name": "Group 9354",
    transform: "translate(19.561 0.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21005",
    "data-name": "Path 21005",
    d: "M1045.049,613.057a14.614,14.614,0,0,0-6.9-5.667,33.609,33.609,0,0,1,2.1,5.667Z",
    transform: "translate(-1038.153 -607.39)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9355",
    "data-name": "Group 9355",
    transform: "translate(0 8.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21006",
    "data-name": "Path 21006",
    d: "M1022.01,615.99h-5.322a15.366,15.366,0,0,0-1.51,5.891h6.1A33.064,33.064,0,0,1,1022.01,615.99Z",
    transform: "translate(-1015.178 -615.99)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9356",
    "data-name": "Group 9356",
    transform: "translate(8.753 23.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30378",
    "data-name": "Path 30378",
    d: "M1030.354,634.731l-2,1.5,2,1.5v2.6a14.48,14.48,0,0,1-2.486-.366,32.283,32.283,0,0,1-2.409-6.241h4.9Z",
    transform: "translate(-1025.458 -633.718)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9357",
    "data-name": "Group 9357",
    transform: "translate(7.699 8.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21008",
    "data-name": "Path 21008",
    d: "M1024.221,621.881h5.951V615.99h-5.177A31.293,31.293,0,0,0,1024.221,621.881Z",
    transform: "translate(-1024.221 -615.99)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9358",
    "data-name": "Group 9358",
    transform: "translate(15.246 8.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    "data-name": "Path 21009",
    d: "M1038.262,615.99h-5.177v5.891h5.95A31.144,31.144,0,0,0,1038.262,615.99Z",
    transform: "translate(-1033.085 -615.99)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9359",
    "data-name": "Group 9359",
    transform: "translate(7.691 15.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21010",
    "data-name": "Path 21010",
    d: "M1024.88,630.743h5.291v-5.891h-5.96A31.226,31.226,0,0,0,1024.88,630.743Z",
    transform: "translate(-1024.211 -624.852)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9360",
    "data-name": "Group 9360",
    transform: "translate(15.249 15.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30379",
    "data-name": "Path 30379",
    d: "M1037.888,631.746l.17-.128v.128Z",
    transform: "translate(-1033.802 -625.854)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30380",
    "data-name": "Path 30380",
    d: "M1037.984,624.848v3.687l-2.937,2.205h-1.958v-5.892Z",
    transform: "translate(-1033.088 -624.848)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9362",
    "data-name": "Group 9362",
    transform: "translate(22.064 8.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21013",
    "data-name": "Path 21013",
    d: "M1041.093,615.99a32.9,32.9,0,0,1,.736,5.891h6.1a15.33,15.33,0,0,0-1.509-5.891Z",
    transform: "translate(-1041.093 -615.99)",
    fill: "#3d72fc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19622",
    "data-name": "Group 19622",
    transform: "translate(13.776 21.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_30303",
    "data-name": "Path 30303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30381",
    "data-name": "Path 30381",
    d: "M1037.088,633.449h10.94v4.93h-10.94v1.831l-5.73-4.291,5.56-4.172.17-.128Z",
    transform: "translate(-1031.358 -631.618)",
    fill: "#002c77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_30304",
    "data-name": "Path 30304",
    transform: "translate(21.422 14.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30382",
    "data-name": "Path 30382",
    d: "M1051.27,631.608v-1.831h-10.932v-4.938h10.932v-1.831l5.739,4.3Z",
    transform: "translate(-1040.338 -623.008)",
    fill: "#ffb063"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineTransactions);
export default __webpack_public_path__ + "static/media/online_transactions.1ad35c6020e81a6ef1650be054619e42.svg";
export { ForwardRef as ReactComponent };